import { useState } from 'react';
import { Button, ListItemIcon, ListItemText, Menu, MenuItem } from '@mui/material';
import FileDownloadOutlinedIcon from '@mui/icons-material/FileDownloadOutlined';
import DescriptionOutlinedIcon from '@mui/icons-material/DescriptionOutlined';
import PrintOutlinedIcon from '@mui/icons-material/PrintOutlined';
import ContentCopyOutlinedIcon from '@mui/icons-material/ContentCopyOutlined';
import PictureAsPdfOutlinedIcon from '@mui/icons-material/PictureAsPdfOutlined';
import type { ActionItem, Newsletter } from '@/types';
import { copyNewsletterToClipboard, exportNewsletterAsHtml, printNewsletter } from '@/services/exportService';
import { useAppDispatch } from '@/store/hooks';
import { showSnackbar } from '@/store/slices/uiSlice';

export default function ExportMenu({ newsletter, actionItems }: { newsletter: Newsletter; actionItems: ActionItem[] }) {
  const [anchorEl, setAnchorEl] = useState<HTMLElement | null>(null);
  const dispatch = useAppDispatch();
  const close = () => setAnchorEl(null);

  return (
    <>
      <Button
        variant="outlined"
        size="small"
        startIcon={<FileDownloadOutlinedIcon fontSize="small" />}
        onClick={(e) => setAnchorEl(e.currentTarget)}
      >
        Export
      </Button>
      <Menu anchorEl={anchorEl} open={Boolean(anchorEl)} onClose={close}>
        <MenuItem
          onClick={() => {
            exportNewsletterAsHtml(newsletter, actionItems);
            close();
          }}
        >
          <ListItemIcon>
            <DescriptionOutlinedIcon fontSize="small" />
          </ListItemIcon>
          <ListItemText>Download HTML</ListItemText>
        </MenuItem>
        <MenuItem
          onClick={() => {
            printNewsletter();
            close();
          }}
        >
          <ListItemIcon>
            <PrintOutlinedIcon fontSize="small" />
          </ListItemIcon>
          <ListItemText>Print</ListItemText>
        </MenuItem>
        <MenuItem
          onClick={() => {
            printNewsletter();
            close();
          }}
        >
          <ListItemIcon>
            <PictureAsPdfOutlinedIcon fontSize="small" />
          </ListItemIcon>
          <ListItemText>Save as PDF (via Print dialog)</ListItemText>
        </MenuItem>
        <MenuItem
          onClick={async () => {
            await copyNewsletterToClipboard(newsletter, actionItems);
            dispatch(showSnackbar({ message: 'Newsletter copied to clipboard', severity: 'success' }));
            close();
          }}
        >
          <ListItemIcon>
            <ContentCopyOutlinedIcon fontSize="small" />
          </ListItemIcon>
          <ListItemText>Copy to Clipboard</ListItemText>
        </MenuItem>
      </Menu>
    </>
  );
}
